import { authClient } from '../services/api.service';
import { AUTH_API_ENDPOINTS } from '../config/api.config';

export interface RoleDto {
  id: number;
  code: string;
  name?: string | null;
  description?: string | null;
}

export interface UserIdentityDto {
  userId: number;
  isActive: boolean;
  roles: RoleDto[];
}

export const AuthIdentityApi = {
  async getEntraIdentity(headers?: Record<string, string>): Promise<UserIdentityDto> {
    const { data } = await authClient.get<UserIdentityDto>(AUTH_API_ENDPOINTS.userEntra, {
      headers,
    });
    if (!data || typeof data !== 'object' || !('userId' in data)) {
      throw new Error(`AuthService returned unexpected shape from ${AUTH_API_ENDPOINTS.userEntra}`);
    }
    return data;
  },
};
